<template>
  <div>
    <loginDialog @loginSuccess="loginSuccess"></loginDialog>
  </div>
</template>

<script>
import loginDialog from "~xif/components/common/loginDialog";
export default {
  metaInfo:{
    title:'厦门货代协会--登录'
  },
  components: { loginDialog },
  data() {
    return {};
  },
  computed: {},
  methods: {
    loginSuccess(){
      this.$router.push('/')
    }
  },
};
</script>
